// store/story/history-selectors.ts
//
// The undo stack the AI Undo affordances gate on, in either editing mode.
//
// undo() pops the NEWEST step, so a turn's change is only reachable through it
// while that turn's aiActionId is still on top — once the user has edited by
// hand since, undo would take back THEIR work. Which stack is "the" stack
// depends on the room: single-seat editing undoes through this slice's
// `history.past`/`current`; a collaborative room undoes through the Yjs
// UndoManager, whose pops never touch this slice — so after a collab undo
// `history.current` still names the turn as newest while the real stack has
// moved on. YjsStoryProvider mirrors the real stack top into `history.collab`
// (setCollabHistoryStatus) while it is mounted; these selectors prefer that
// mirror and fall back to the Redux frame when there is no room.
//
// Kept apart from ./selectors.ts on purpose: the agent's undo command
// (undo-last-change.ts) runs outside StoryHistoryContext, so it can only read
// the Redux store — and the affordances' tests fake `@store` with a bare
// state, which the heavy selectors module would not survive.
import type { RootState } from "@/store";

// The aiActionId on the newest undo step, or null when that step is not an AI
// turn's — a user edit, or an empty stack.
export const selectTopAiActionId = (state: RootState): string | null => {
  const { collab, current } = state.story.history;
  if (collab) return collab.topAiActionId;
  return current?.aiActionId ?? null;
};

export const selectCanUndoStory = (state: RootState): boolean => {
  const { collab, past } = state.story.history;
  if (collab) return collab.canUndo;
  return past.length > 0;
};
